import { useCallback, useEffect, useRef, useState } from "react";

const DEFAULT_TIMEOUT_MS = 1500;

interface UseClipboardOptions {
  timeout?: number;
}

export function useClipboard(text: string, options?: UseClipboardOptions) {
  const timeout = options?.timeout ?? DEFAULT_TIMEOUT_MS;
  const [hasCopied, setHasCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(
    undefined
  );

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  const onCopy = useCallback(() => {
    if (!text) return;

    void window.navigator.clipboard.writeText(text).then(
      () => {
        setHasCopied(true);

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
          setHasCopied(false);
        }, timeout);
      },
      () => {
        setHasCopied(false);
      }
    );
  }, [text, timeout]);

  return { onCopy, hasCopied, value: text };
}
